module.exports = __webpack_public_path__ + "e6f097f93a69b28225c43e25fdcaf709.svg";